export enum ProjectStatusEnum {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
}
